function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const overviewTitles = {
  site: 'Sites',
  tc: 'Traject Controles'
};

const detailTitles = {
  site: 'Site',
  tc: 'Traject Controle'
};

const deleteTitles = {
  site: 'deze site',
  tc: 'deze traject controle'
};

const urls = {
  site: '/sites/sites',
  tc: '/routecontrols/routecontrols'
};

const newRecordCommon = {
  devicetype_id: 0,
  is_active: true,
  highway: false,
  trafficlight: false
};

const newRecords = {
  site: { site_count: 2 },
  tc: { site_count: 0 }
};

const filterNames = {
  site: 'sites',
  tc: 'tc'
};

const deviceGroupViewIds = {
  site: 2,
  tc: 3
};

const getTableFields = {
  site: [
    {
      text: 'Serienummer',
      value: 'serial_nr',
      link: '/sites/sites/{id}',
      width: '30%'
    },
    {
      text: 'Type',
      value: 'sitetype',
      width: '25%'
    },
    {
      text: 'Installatienummer',
      value: 'installation_nr',
      width: '25%'
    },
    {
      text: 'Aantal palen',
      value: 'site_count',
      width: '10%'
    }
  ],
  tc: [
    {
      text: 'Serienummer',
      value: 'serial_nr',
      link: '/routecontrols/routecontrols/{id}',
      width: '40%'
    },
    {
      text: 'Type',
      value: 'sitetype',
      width: '40%'
    },
    {
      // tslint:disable-next-line: quotemark
      text: "Aantal Camera's",
      value: 'site_count',
      width: '10%'
    }
  ]
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle(context) {
    return overviewTitles[getType(context)];
  },
  detailTitle(context) {
    return detailTitles[getType(context)];
  },
  deleteTitle(context) {
    return deleteTitles[getType(context)];
  },
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sites/',
  sortBy: ['serial_nr'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  forEdit: true,
  newRecord(context) {
    return { ...newRecordCommon, ...newRecords[getType(context)] };
  },
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'string'
  },
  advancedSearchFields(context) {
    return [
      {
        text: 'Type',
        value: 'sitetype_id',
        type: 'optionList',
        optionListName: 'sitetypes',
        optionListParams: {
          devicegroupview_id: deviceGroupViewIds[getType(context)]
        }
      },
      {
        text: 'Beheerder',
        value: 'admin_address_id',
        type: 'optionList',
        optionListName: 'addresses',
        optionListParams: { priv_manager: 'yes' }
      },
      {
        text: 'Toezichter',
        value: 'supervisor_id',
        type: 'optionList',
        optionListName: 'supervisors'
      }
    ];
  },
  tableFields(context) {
    return getTableFields[getType(context)];
  }
};
